import { SxProps, Theme } from '@mui/material/styles';

/** Outer wrapper for request + workflow form pages (one product shell). */
export const requestFormPageShellSx: SxProps<Theme> = {
  backgroundColor: '#f6f8fc',
  maxWidth: 1400,
  mx: 'auto',
  p: { md: 2, xs: 1 },
};

/** Top row: back, centered title, optional trailing control slot. */
export const requestFormHeaderRowSx: SxProps<Theme> = {
  alignItems: 'center',
  display: 'flex',
  gap: 2,
  mb: 3,
  mt: 2,
  position: 'relative',
};

/** Main form surface inside the page shell. */
export const requestFormPaperSx: SxProps<Theme> = {
  border: '1px solid rgba(22,56,96,0.12)',
  borderRadius: 3,
  boxShadow: '0 10px 30px rgba(15, 23, 42, 0.06)',
  display: 'flex',
  flexDirection: 'column',
  p: { md: 3, xs: 2 },
};

/** Home dashboard cards (request types / history) — same chrome as form Paper, no inner padding. */
export const dashboardCardSx: SxProps<Theme> = {
  backgroundColor: '#ffffff',
  border: '1px solid rgba(22,56,96,0.12)',
  borderRadius: 3,
  boxShadow: '0 10px 30px rgba(15, 23, 42, 0.06)',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};
